import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import "./styles.scss";

import logoCompany from "../../assets/img/companyLogo.png";

import services from "../../services";

const Header = () => {
  const history = useHistory();

  const [nomeUsuario, setNomeUsuario] = useState("");

  useEffect(() => {
    const { nome } = services.storage.getUser();
    setNomeUsuario(nome);
  });

  const deslogar = () => {
    services.storage.clear();
    history.push("/");
  };

  return (
    <div className="container-page header">
      <div className="row header-content">
        <div className="profile">
          {/* <img src={logoCompany} alt="teste"/> */}
          <div>
            <span>Olá, {nomeUsuario}</span>
          </div>
        </div>
        <div className="separador"></div>
        <button type="button" onClick={deslogar}>
          Sair
        </button>
      </div>
    </div>
  );
};

export default Header;
